import React from 'react'

export default function LostPage() {
    return (
        <div className="LostPage bg-black text-white h-screen flex justify-center items-center">
            <span>You might be lost!</span>
        </div>
    )
}
